import { showErrorToast } from "@/services";

export const formatErrorMessage = (error) => {
  const apiErrorMessage = error?.response?.data?.error;

  const statusError = error.response?.status
    ? `${error.response?.status}, ${error?.response?.statusText}`
    : null;
  const defaultError = "Ошибка при выполнении запроса";
  return apiErrorMessage || statusError || defaultError;
};

export const handleApiError = (error, options = {}) => {
  const { showToast = true, throwError = false } = options;
  const data = error?.response?.data || {};
  const isManualChoice = data.is_manual === true || (typeof data.error === 'string' && (data.error.includes('ручным вводом') || data.error.includes('удалить или сохранить')));

  if (showToast && !isManualChoice) {
    showErrorToast(formatErrorMessage(error));
  }
  return throwError || isManualChoice
    ? Promise.reject(error)
    : Promise.reject(formatErrorMessage(error));
};
